/**
 * Central registry for analytics event names.
 *
 * Keep event values stable after releasing them because changing a value
 * creates a separate event in the analytics dashboard.
 */
export const ANALYTICS_EVENTS = {
  BOOK_A_DEMO_CLICKED: 'book_a_demo_clicked',
  EXPLORE_PLATFORM_CLICKED: 'explore_platform_clicked',

  ENQUIRY_SUBMIT_CLICKED: 'enquiry_submit_clicked',
  ENQUIRY_SUBMITTED_ATTEMPTED: 'enquiry_submitted_attempted',
  ENQUIRY_SUBMITTED: 'enquiry_submitted',
  ENQUIRY_SUBMISSION_FAILED: 'enquiry_submission_failed',

  NEWSLETTER_SUBSCRIBE_CLICKED: 'newsletter_subscribe_clicked',
  NEWSLETTER_SUBSCRIBE_ATTEMPTED: 'newsletter_subscribe_attempted',
  NEWSLETTER_SUBSCRIBED: 'newsletter_subscribed',
  NEWSLETTER_SUBSCRIPTION_FAILED: 'newsletter_subscription_failed',

  WHATSAPP_CLICKED: 'whatsapp_clicked',
  LINKEDIN_CLICKED: 'linkedin_clicked',
  INSTAGRAM_CLICKED: 'instagram_clicked',
  TWITTER_CLICKED: 'twitter_clicked',
  YOUTUBE_CLICKED: 'youtube_clicked',

  VIDEO_PLAYED: 'video_played',
  VIDEO_PAUSED: 'video_paused',
  VIDEO_COMPLETED: 'video_completed',
} as const;
